import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

export const useCampaignCode = () => {
  const [searchParams] = useSearchParams();
  const campaignCode = searchParams.get('campaignCode') || undefined;

  const appendCampaignCode = useCallback(
    (url: string, additionalParams?: URLSearchParams) => {
      const params = new URLSearchParams(additionalParams);

      if (campaignCode) {
        params.set('campaignCode', campaignCode);
      }

      const queryString = params.toString();

      if (!queryString) {
        return url;
      }

      const hashIndex = url.indexOf('#');
      const baseUrl = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
      const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';

      const cleanBaseUrl = baseUrl.endsWith('?')
        ? baseUrl.slice(0, -1)
        : baseUrl;
      const separator = cleanBaseUrl.includes('?') ? '&' : '?';

      return `${cleanBaseUrl}${separator}${queryString}${hash}`;
    },
    [campaignCode],
  );

  const createParamsWithCampaignCode = useCallback(
    (additionalParams?: Record<string, string>) => {
      const params = new URLSearchParams(additionalParams);

      if (campaignCode) {
        params.set('campaignCode', campaignCode);
      }

      return params;
    },
    [campaignCode],
  );

  return {
    appendCampaignCode,
    campaignCode,
    createParamsWithCampaignCode,
  };
};
